import { motion } from 'framer-motion';

export default function PhotoDivider({ image, text, testid }) {
  return (
    <div
      className="relative h-[42vh] overflow-hidden bg-cover bg-center bg-scroll sm:h-[58vh] md:bg-fixed"
      style={{ backgroundImage: `url(/fotos/${image}.jpg)` }}
      data-testid={testid}
    >
      <div className="absolute inset-0 bg-[#0D0D0F]/55" />
      <div className="relative z-10 flex h-full items-center justify-center px-4">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="text-center font-display text-4xl uppercase leading-none text-white drop-shadow-[0_4px_24px_rgba(0,0,0,0.8)] sm:text-6xl"
        >
          {text}
        </motion.p>
      </div>
    </div>
  );
}
